import { motion } from 'framer-motion';
import { Landmark, Building2, ShieldOff, Lock, Quote } from 'lucide-react';

const CARD_ICONS = [Landmark, Building2, ShieldOff, Lock];

const Credentials = ({ t }) => {
  const c = t.credentials;
  return (
    <section id="credentials" className="relative py-20 sm:py-24 lg:py-28 bg-[rgb(var(--bg-1))]" data-testid="credentials">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-2xl mx-auto mb-14">
          <div className="kicker-mono mb-3">{c.kicker}</div>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-[650] tracking-tight text-white" data-testid="credentials-title">
            {c.title}
          </h2>
          <p className="mt-4 text-white/70 text-base sm:text-lg">{c.subtitle}</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-12">
          {c.cards.map((card, i) => {
            const Icon = CARD_ICONS[i] || Lock;
            return (
              <motion.div
                key={card.name}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.45, delay: i * 0.07 }}
                whileHover={{ y: -3 }}
                className="rounded-2xl border border-white/10 bg-[rgb(var(--bg-2))] p-5 hover:border-[rgba(5,126,243,.5)] transition-colors"
                data-testid={`credential-card-${i}`}
              >
                <div className="h-11 w-11 rounded-xl bg-[rgba(5,126,243,.12)] border border-[rgba(5,126,243,.35)] flex items-center justify-center text-[rgb(var(--brand-electric))]">
                  <Icon size={20} />
                </div>
                <div className="mt-4 font-display text-lg font-[650] text-white">{card.name}</div>
                <div className="mt-1.5 text-sm text-white/65 leading-relaxed">{card.desc}</div>
              </motion.div>
            );
          })}
        </div>

        {/* Signature quote */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.55 }}
          className="gradient-border"
          data-testid="credentials-quote"
        >
          <div className="inner p-8 sm:p-12 text-center">
            <Quote size={28} className="mx-auto text-[rgb(var(--brand-electric))] mb-5" />
            <div className="font-display text-2xl sm:text-3xl lg:text-4xl font-[650] text-white tracking-tight leading-tight">
              {c.quote}
            </div>
            <div className="mt-4 text-sm text-white/60 max-w-md mx-auto">{c.quote_footer}</div>
          </div>
        </motion.div>

        {/* Industries */}
        <div className="mt-12 text-center">
          <div className="kicker-mono mb-4 text-white/60">{c.industries_kicker}</div>
          <div className="flex flex-wrap justify-center gap-2.5" data-testid="industries-badges">
            {c.industries.map((ind) => (
              <span key={ind} className="chip"><span className="dot" />{ind}</span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Credentials;
